module.exports = __webpack_public_path__ + "media/audio24.a86d7cca.mp3";